import React from "react";

type IconProps = {
  className?: string;
  title?: string;
};

// these are intentionally simple, inline svg icons
// colors are baked in to match the minimal style reference

export const MorningIcon: React.FC<IconProps> = ({ className = "", title }) => {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title || "morning"}
    >
      {/* sun */}
      <circle cx="18" cy="18" r="7" stroke="#F59E0B" strokeWidth="4" />
      <path d="M18 5V2" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />
      <path d="M5 18H2" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />
      <path d="M9 9L7 7" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />
      <path d="M27 9L29 7" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />

      {/* mountains */}
      <path
        d="M10 48L26 30L38 40L54 22L62 30V56H2V48H10Z"
        stroke="#60A5FA"
        strokeWidth="4"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MiddayIcon: React.FC<IconProps> = ({ className = "", title }) => {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title || "midday"}
    >
      <circle cx="32" cy="32" r="11" stroke="#F59E0B" strokeWidth="4" />
      {/* rays */}
      <path d="M32 6V14" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />
      <path d="M32 50V58" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />
      <path d="M6 32H14" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />
      <path d="M50 32H58" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />
      <path d="M14 14L19 19" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />
      <path d="M45 45L50 50" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />
      <path d="M50 14L45 19" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />
      <path d="M19 45L14 50" stroke="#F59E0B" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
};

export const EveningIcon: React.FC<IconProps> = ({ className = "", title }) => {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title || "evening"}
    >
      {/* sun half */}
      <path
        d="M18 34C18 26.268 24.268 20 32 20C39.732 20 46 26.268 46 34"
        stroke="#FB7185"
        strokeWidth="4"
        strokeLinecap="round"
      />
      {/* horizon lines */}
      <path d="M10 38H54" stroke="#FB7185" strokeWidth="4" strokeLinecap="round" />
      <path d="M14 46H50" stroke="#FB7185" strokeWidth="4" strokeLinecap="round" />
      <path d="M18 54H46" stroke="#FB7185" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
};

export const NightIcon: React.FC<IconProps> = ({ className = "", title }) => {
  return (
    <svg
      className={className}
      width="28"
      height="28"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title || "night"}
    >
      {/* crescent moon */}
      <path
        d="M40 14C31 16 24 24 24 34C24 44 31 52 40 54C30 54 18 46 18 32C18 18 30 10 40 14Z"
        stroke="#A78BFA"
        strokeWidth="4"
        strokeLinejoin="round"
      />
      {/* stars */}
      <path d="M50 20L50 20" stroke="#A78BFA" strokeWidth="8" strokeLinecap="round" />
      <path d="M54 34L54 34" stroke="#A78BFA" strokeWidth="6" strokeLinecap="round" />
      <path d="M46 40L46 40" stroke="#A78BFA" strokeWidth="6" strokeLinecap="round" />
    </svg>
  );
};
